












































import {Mixins, Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import {Style, Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";
import _ from "lodash";
import {Getter} from "vuex-class";
import {PowerBiReport} from "@/modules/PowerBi";

const components = {
    Container,
};

interface ImageLinkParameters extends WidgetParameters {
    imageUrl?: string;
    cta?: {
        label: string;
        url?: string;
        route?: string;
        reportUuid: string;
    };
}

interface ImageLinkData extends Widget {
    parameters: ImageLinkParameters;
}

@Component({components})
export default class ImageDynamicLinkReport extends Mixins(DashboardMixin) {
    @Prop({default: null}) public widget !: ImageLinkData;

    @Getter("getOwnerReports") public ownerReports!: PowerBiReport[];

    protected get hasCta(): boolean {
        return !!(_.get(this.widget.parameters, "cta", false) && (this.link || this.isRouteLink));
    }

    protected get isRouteLink(): boolean {
        return _.get(this.widget.parameters, "cta.route", false);
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected link(): string {
        const url = _.get(this, "widget.parameters.cta.url", false);
        if (!url) {
            return "";
        }
        const reportMatch = _.find(this.ownerReports, (report) => {
            return report.linkReports === _.get(this, "widget.parameters.cta.reportUuid", false);
        });

        if (reportMatch) {
            return url.replace("[REPORT_UUID]", reportMatch.uuid);
        }

        return "";
    }

    protected goToCta(): void {
        if (this.link()) {
            window.location.href = this.link();
        } else if (this.isRouteLink && this.widget?.parameters?.cta?.route) {
            this.$router.push(this.widget.parameters.cta.route);
        }
    }
}
